import { Component, Input, OnInit } from '@angular/core';
import IGISDataCacheStatistic = ZoningAPI.IGISDataCacheStatistic;
import { bytesToKiloBytes, millisecondsToSeconds } from 'src/app/shared/utils/utils';

@Component({
    standalone: false,
    selector: 'app-process-gis-data-cache-statistic',
    templateUrl: './process-gis-data-cache-statistic.component.html',
    styleUrls: ['./process-gis-data-cache-statistic.component.scss']
})
export class ProcessGisDataCacheStatisticComponent implements OnInit {
    @Input()
    gisDataCacheStatistic: IGISDataCacheStatistic;

    bytesToKiloBytes = bytesToKiloBytes;
    millisecondsToSeconds = millisecondsToSeconds;

    constructor() {}

    ngOnInit(): void {}
}
